import { render, staticRenderFns } from "./SEOAndPPCPage.vue?vue&type=template&id=16bfff6f&"
import script from "./SEOAndPPCPage.vue?vue&type=script&lang=js&"
export * from "./SEOAndPPCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports